import { BoxRow } from './BoxRow/BoxRow';
import { BoxRowImageItem } from './BoxRowImageItem/BoxRowImageItem';

//<CE-compontent in uppercase> : <Project component>
export const contentEditorComponents = {
  BOXROW: BoxRow,
  BOXROWIMAGEITEM: BoxRowImageItem
};
